import React from 'react';
import { motion } from 'framer-motion';
interface HighlightProps {
  children: React.ReactNode;
  className?: string;
}
export function Highlight({
  children,
  className = ''
}: HighlightProps) {
  return <span className="relative inline-block" data-id="element-111">
      <motion.span initial={{
      width: 0
    }} whileInView={{
      width: '100%'
    }} viewport={{
      once: true
    }} transition={{
      duration: 1.5,
      delay: 0.2,
      ease: 'easeOut'
    }} className={`absolute inset-0 bg-gradient-to-r from-yellow-400/80 to-yellow-500/80 rounded-sm -z-10 ${className}`} style={{
      padding: '0.1em 0'
    }} data-id="element-112" />
      {children}
    </span>;
}